import { getEditLocation } from "../../../core/util/functions";

export const orderIndLocation = "/trading/indicativeorders";
export const getOrderIndEditLocation = (id?: number | string) => getEditLocation(orderIndLocation, undefined, id?.toString());

export const editRouter = getOrderIndEditLocation(":orderIndId?");
